import { POST_TYPES } from "../../../../constants/PostsView";
import {
  MediaFilesErrors,
  MediaFilesWarning,
  Post,
} from "../../../../features/post";
import { isDocumentMedia } from "../../../../utils/media";

export const validateLinkedIn = ({
  mediaErrors,
  mediaWarnings,
  mediaFiles,
  post,
  videoIndexes,
  imageIndexes,
}: {
  mediaErrors: MediaFilesErrors;
  mediaWarnings: MediaFilesWarning;
  mediaFiles: Post["mediaFiles"];
  post: Post;
  videoIndexes: number[];
  imageIndexes: number[];
}) => {
  // only one document allowed per post
  if (
    post.type === POST_TYPES.DOCUMENT &&
    mediaFiles &&
    mediaFiles.length > 1
  ) {
    mediaErrors.LIDocumentsLimit = true;
  }

  if (mediaFiles.some((c) => isDocumentMedia(c)) && mediaFiles.length > 1) {
    mediaErrors.LIDocumentsLimit = true;
  }
  // if only 1 video, that is fine. Run validations if > 1 video
  if (videoIndexes.length > 0) {
    if (imageIndexes.length > 0) {
      mediaWarnings.LIVideosInCarouselIndexes = videoIndexes;
    } else if (videoIndexes.length === 1) {
      // do nothing, this is fine as post has only 1 video
    } else {
      // no images and > 1 video - this will not post to LinkedIn at all
      mediaErrors.LIVideosInCarouselIndexes = videoIndexes;
    }
  }
  // Failed. com.linkedin.content.common.ResponseException: Media length greater than 9 not supported for images.
  if (imageIndexes && imageIndexes.length > 9) {
    mediaErrors.LIImagesLimit = true;
  }
};
